import ApplicationSerializer from 'lumen/serializers/application';

export default class SubscriptionUserSerializer extends ApplicationSerializer {
  primaryKey = 'user_id';

  modelNameFromPayloadKey(key: string): string {
    if (key === 'users') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return super['modelNameFromPayloadKey']('subscription-users');
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super['modelNameFromPayloadKey'](key);
  }
}
